import {Pipe, PipeTransform} from '@angular/core';
import {DateTime} from 'luxon';

@Pipe({
    name: 'whatsAppCategory',
    standalone: true
})
export class WhatsAppCategoryPipe implements PipeTransform {

  transform(value: string): string {

    switch (value) {
      case 'ACCOUNT_UPDATE':
        return 'Account Update';
      case 'PAYMENT_UPDATE':
        return 'Payment Update';
      case 'PERSONAL_FINANCE_UPDATE':
        return 'Personal Finance Update';
      case 'SHIPPING_UPDATE':
        return 'Shipping Update';
      case 'RESERVATION_UPDATE':
        return 'Reservation Update';
      case 'ISSUE_RESOLUTION':
        return 'Issue Resolution';
      case 'APPOINTMENT_UPDATE':
        return 'Appointment Update';
      case 'TRANSPORTATION_UPDATE':
        return 'Transportation Update';
      case 'TICKET_UPDATE':
        return 'Ticket Update';
      case 'ALERT_UPDATE':
        return 'Alert Update';
      case 'AUTO_REPLY':
        return 'Auto Reply';
      case 'TRANSACTIONAL':
        return 'Transactional';
      case 'OTP':
        return 'OTP';
      case 'UTILITY':
        return 'Utility';
      case 'MARKETING':
        return 'Marketing';
      case 'AUTHENTICATION':
        return 'Authentication';
      default:
        return value;
    }
  }
}
